import React from "react";
import { Button } from "@mui/material";
import { colors } from "../constants/colors";

const CustomButton = ({ text, onClick }) => {
  return (
    <Button
      variant="outlined" // Outlined button style
      sx={{
        color: colors.primary, // Text color
        borderColor: colors.primary, // Border color
        borderRadius: "15px", // Rounded corners
        textTransform: "none", // Prevent uppercase transformation
        width: "200px", // Width of the button
        backgroundColor: colors.white, // White background
        padding: "20px", // Padding
        "&:hover": {
          backgroundColor: colors.secondary, // Change background on hover
          color: colors.white, // Change text color on hover
          borderColor: colors.primary, // Keep border color same on hover
        },
        "&:active": {
          backgroundColor: colors.darkPrimary, // Darker background on click
          color: colors.white, // Keep text color white on active
        },
        "&:focus": {
          outline: "none", // Remove focus outline
        },
      }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
